"use client";

import { Shield, ShieldCheck, TrendingDown } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Benefits() {
  const intro = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const tile1 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const tile2 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const tile3 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const tile4 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const tile5 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const refreshForecast = [{
    quarter: "Q1",
    height: 38,
    highlight: false
  }, {
    quarter: "Q2",
    height: 56,
    highlight: true
  }, {
    quarter: "Q3",
    height: 72,
    highlight: false
  }, {
    quarter: "Q4",
    height: 84,
    highlight: false
  }];
  return <section data-section-id="12345" id="industryversatilitybenefits" className="bg-background text-foreground py-[clamp(4rem,8vw,7rem)] px-[clamp(1.25rem,4vw,2.5rem)]">
      <div className="mx-auto max-w-[1280px]">
        {}
        <div ref={intro.ref} data-index={0} className="mx-auto max-w-[720px] text-center mb-16 md:mb-20 transition-all duration-700 ease-out" style={{
        opacity: intro.isVisible ? 1 : 0,
        transform: intro.isVisible ? "translateY(0)" : "translateY(16px)"
      }}>
          <h2 className="font-default font-semibold text-[clamp(2rem,4vw,3.5rem)] leading-[1.05] tracking-tight text-foreground">
            A{" "}
            <span className="font-serif italic font-normal inline-block transition-all duration-500" style={{
            opacity: intro.isVisible ? 1 : 0,
            transform: intro.isVisible ? "translateX(0)" : "translateX(-4px)",
            transitionDelay: "120ms"
          }}>
              precisão
            </span>{" "}
            na engenharia.
          </h2>
          <p className="mt-5 text-[clamp(1.0625rem,1.2vw,1.25rem)] leading-[1.55] text-muted-foreground">
            A Eurocontrol transforma sistemas complexos em resultados mensuráveis — maior eficiência, menor desperdício e controlo total.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mb-6">
          {}
          <div ref={tile1.ref} data-index={0} className="lg:col-span-8 rounded-3xl border border-border bg-card p-[clamp(2rem,3vw,2.75rem)] transition-all duration-[320ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] hover:-translate-y-[3px] hover:border-primary/25 hover:shadow-lg" style={{
          opacity: tile1.isVisible ? 1 : 0,
          transform: tile1.isVisible ? "translateY(0)" : "translateY(16px)",
          transitionProperty: "opacity, transform, border-color, box-shadow",
          transitionDuration: "520ms, 520ms, 320ms, 320ms",
          transitionDelay: "0ms",
          background: "radial-gradient(circle at top left, hsl(215 80% 20%) 0%, hsl(215 80% 15%) 70%)"
        }}>
            <h3 className="font-default font-semibold text-[clamp(1.25rem,1.6vw,1.625rem)] leading-[1.15] tracking-tight text-foreground">
              Redução de Desperdício
            </h3>
            <p className="mt-4 text-[0.9375rem] leading-[1.6] text-muted-foreground max-w-[52ch]">
              Bicos ineficientes e sistemas desajustados drenam recursos preciosos. A Eurocontrol otimiza cada gota, garantindo que o seu processo industrial utilize apenas o necessário. Reduzimos custos operacionais, aumentamos a vida útil dos equipamentos e garantimos uma produção sustentável e altamente rentável.
            </p>

            {}
            <div className="mt-8">
              <div className="flex items-center justify-between mb-3">
                <span className="font-mono text-xs uppercase tracking-[0.08em] text-muted-foreground">
                  Eficiência média alcançada
                </span>
                <span className="font-mono text-xs text-primary">
                  {"-34%"}
                </span>
              </div>
              <div className="relative h-2 w-full rounded-md bg-secondary overflow-hidden">
                <div className="absolute inset-y-0 left-0 bg-primary rounded-md transition-all duration-[1100ms] ease-out" style={{
                width: tile1.isVisible ? "66%" : "100%",
                transitionDelay: "300ms"
              }} />
              </div>
              <div className="mt-2 flex justify-between font-mono text-[0.6875rem] text-muted-foreground">
                <span>{"Consumo Base 100%"}</span>
                <span>{"Com Eurocontrol 66%"}</span>
              </div>
            </div>
          </div>

          {}
          <div ref={tile2.ref} data-index={1} className="lg:col-span-4 rounded-2xl border border-border bg-card p-8 flex flex-col justify-between transition-all duration-[320ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] hover:-translate-y-[3px] hover:border-primary/25 hover:shadow-lg" style={{
          opacity: tile2.isVisible ? 1 : 0,
          transform: tile2.isVisible ? "translateY(0)" : "translateY(16px)",
          transitionProperty: "opacity, transform, border-color, box-shadow",
          transitionDuration: "520ms, 520ms, 320ms, 320ms",
          transitionDelay: "80ms"
        }}>
            <TrendingDown className="size-6 text-primary" strokeWidth={1.5} />
            <div className="mt-12">
              <h4 className="font-default font-medium text-[clamp(1rem,1.1vw,1.125rem)] leading-[1.25] tracking-tight text-foreground">
                Poupança média
              </h4>
              <p className="mt-2 font-mono text-xs text-muted-foreground">
                {"34% no primeiro ano"}
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mb-6">
          {}
          <div ref={tile3.ref} data-index={0} className="lg:col-span-4 lg:order-1 rounded-2xl border border-border bg-card p-8 flex flex-col justify-between transition-all duration-[320ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] hover:-translate-y-[3px] hover:border-primary/25 hover:shadow-lg" style={{
          opacity: tile3.isVisible ? 1 : 0,
          transform: tile3.isVisible ? "translateY(0)" : "translateY(16px)",
          transitionProperty: "opacity, transform, border-color, box-shadow",
          transitionDuration: "520ms, 520ms, 320ms, 320ms",
          transitionDelay: "0ms"
        }}>
            <Shield className="size-6 text-primary" strokeWidth={1.5} />
            <div className="mt-12">
              <h4 className="font-default font-medium text-[clamp(1rem,1.1vw,1.125rem)] leading-[1.25] tracking-tight text-foreground">
                Conformidade técnica
              </h4>
              <p className="mt-2 font-mono text-xs text-muted-foreground">
                {"99.4% de sucesso"}
              </p>
            </div>
          </div>

          {}
          <div ref={tile4.ref} data-index={1} className="lg:col-span-8 lg:order-2 rounded-3xl border border-border bg-card p-[clamp(2rem,3vw,2.75rem)] transition-all duration-[320ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] hover:-translate-y-[3px] hover:border-primary/25 hover:shadow-lg" style={{
          opacity: tile4.isVisible ? 1 : 0,
          transform: tile4.isVisible ? "translateY(0)" : "translateY(16px)",
          transitionProperty: "opacity, transform, border-color, box-shadow",
          transitionDuration: "520ms, 520ms, 320ms, 320ms",
          transitionDelay: "80ms",
          background: "radial-gradient(circle at top left, hsl(215 80% 20%) 0%, hsl(215 80% 15%) 70%)"
        }}>
            <h3 className="font-default font-semibold text-[clamp(1.25rem,1.6vw,1.625rem)] leading-[1.15] tracking-tight text-foreground">
              Fiabilidade Industrial
            </h3>
            <p className="mt-4 text-[0.9375rem] leading-[1.6] text-muted-foreground max-w-[52ch]">
              Cada sistema de pulverização é um ponto crítico na sua linha de produção. A Eurocontrol garante monitorização contínua, detetando desvios e falhas antes que impactem a qualidade. Com tecnologia de ponta, asseguramos que a sua operação decorra sem interrupções, mantendo os padrões de segurança mais exigentes.
            </p>

            {}
            <div className="mt-8 rounded-xl border border-border bg-popover p-5">
              <div className="flex items-center justify-between mb-4">
                <span className="font-mono text-xs uppercase tracking-[0.08em] text-muted-foreground">
                  Estado do sistema
                </span>
                <div className="flex items-center gap-2">
                  <span className="size-1.5 rounded-md bg-primary animate-pulse" />
                  <span className="font-mono text-[0.6875rem] uppercase tracking-[0.08em] text-primary">
                    Ativo
                  </span>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="flex items-baseline gap-2">
                  <span className="font-default font-semibold text-3xl text-foreground">
                    3
                  </span>
                  <span className="font-mono text-xs text-destructive">
                    críticos
                  </span>
                </div>
                <div className="flex items-baseline gap-2">
                  <span className="font-default font-semibold text-3xl text-foreground">
                    12
                  </span>
                  <span className="font-mono text-xs text-muted-foreground">
                    normais
                  </span>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-border flex items-center justify-between">
                <span className="font-mono text-[0.6875rem] text-muted-foreground">
                  {"Última verificação: 38s atrás"}
                </span>
                <ShieldCheck className="size-4 text-primary" strokeWidth={1.5} />
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div ref={tile5.ref} data-index={0} className="lg:col-span-12 rounded-3xl border border-border bg-card p-[clamp(2rem,3vw,2.75rem)] transition-all duration-[320ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] hover:-translate-y-[3px] hover:border-primary/25 hover:shadow-lg" style={{
          opacity: tile5.isVisible ? 1 : 0,
          transform: tile5.isVisible ? "translateY(0)" : "translateY(16px)",
          transitionProperty: "opacity, transform, border-color, box-shadow",
          transitionDuration: "520ms, 520ms, 320ms, 320ms",
          transitionDelay: "0ms",
          background: "radial-gradient(circle at top left, hsl(215 80% 20%) 0%, hsl(215 80% 15%) 70%)"
        }}>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
              <div className="lg:col-span-5">
                <h3 className="font-default font-semibold text-[clamp(1.25rem,1.6vw,1.625rem)] leading-[1.15] tracking-tight text-foreground">
                  Planeamento Estratégico
                </h3>
                <p className="mt-4 text-[0.9375rem] leading-[1.6] text-muted-foreground">
                  Ciclos de vida, manutenção preventiva e orçamentos de investimento centralizados. A Eurocontrol projeta a evolução dos seus sistemas, permitindo que a gestão tome decisões informadas para os próximos trimestres com total clareza e previsibilidade.
                </p>
              </div>

              {}
              <div className="lg:col-span-7 w-full">
                <div className="flex items-center justify-between mb-5">
                  <span className="font-mono text-xs uppercase tracking-[0.08em] text-muted-foreground">
                    Previsão de upgrades — Q1 a Q4
                  </span>
                  <span className="font-mono text-[0.6875rem] uppercase tracking-[0.08em] text-primary border border-primary/30 rounded-md px-2.5 py-1">
                    Próximo Q2
                  </span>
                </div>
                <div className="grid grid-cols-4 gap-3 h-40">
                  {refreshForecast.map((item, i) => <div key={item.quarter} data-index={i} className="flex flex-col justify-end items-center gap-3">
                      <div className={`w-full rounded-md transition-all duration-[1100ms] ease-out ${item.highlight ? "bg-primary" : "bg-secondary"}`} style={{
                    height: tile5.isVisible ? `${item.height}%` : "0%",
                    transitionDelay: `${300 + i * 100}ms`
                  }} />
                      <span className={`font-mono text-xs ${item.highlight ? "text-primary" : "text-muted-foreground"}`}>
                        {item.quarter}
                      </span>
                    </div>)}
                </div>
                <div className="mt-4 pt-4 border-t border-border flex items-center justify-between font-mono text-[0.6875rem] text-muted-foreground">
                  <span>{"Sistemas agendados: 1.284"}</span>
                  <span>{"Investimento: 2.1M€"}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}